import { render, staticRenderFns } from "./loadingMainApp.vue?vue&type=template&id=1c621069&scoped=true&"
import script from "./loadingMainApp.vue?vue&type=script&lang=js&"
export * from "./loadingMainApp.vue?vue&type=script&lang=js&"
import style0 from "./loadingMainApp.vue?vue&type=style&index=0&id=1c621069&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c621069",
  null
  
)

export default component.exports